import React from 'react';
import { Button } from '@material-ui/core';
import styled from 'styled-components';

const YearItem = ({ onSetYear, selectedYear, year }) => {
  return (
    <YearButton
      variant='contained'
      color={year !== selectedYear ? 'primary' : 'secondary'}
      onClick={() => onSetYear(year)}
    >
      {year}
    </YearButton>
  );
};

const YearButton = styled(Button)`
  margin: 1em;
`;

export default YearItem;
